<template>
  <div>
    <b-tabs
      v-if="reportDataAll.length"
      pills
      fill
      vertical
      small
      card
      nav-wrapper-class="rounded bg-white shadow"
      nav-class="pt-1 px-1"
    >
      <b-tab
        v-for="(item,key) in reportDataAll"
        :key="key"
        class="pl-0 pr-0 mt-n2"
        :active="key + 1 === reportDataAll.length"
      >
        <template #title>
          <div class="width-100 d-flex align-items-center text-left justify-content-between">
            <span>{{ item.title }}</span>
            <feather-icon icon="CalendarIcon" />
          </div>
        </template>
        <div class="ml-2">
          <b-card
            :title="item.title"
            no-body
          >
            <b-card-header>
              <b-card-title>{{ item.title }}</b-card-title>
            </b-card-header>
            <b-table-simple bordered>
              <b-thead>
                <b-tr>
                  <b-th>Marka / Lokasyon</b-th>
                  <b-th>Satış</b-th>
                  <b-th>Servis</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="(row,index) in item.data"
                  :key="index"
                >
                  <b-td>
                    {{ row.title }}
                  </b-td>
                  <b-td>{{ row.sale? row.sale : '-' }}</b-td>
                  <b-td>{{ row.service? row.service : '-' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab, BCard, BCardHeader, BCardTitle, BTableSimple, BThead, BTr, BTh, BTd, BTbody,
} from 'bootstrap-vue'

export default {
  name: 'CsiTabs',
  components: {
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardTitle,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
  },
  computed: {
    reportDataAll() {
      return this.$store.getters['crmCsiReports/reportDataAll']
    },
  },
}
</script>
